import { extractDay, getCurrencyChoice, getTileSide, parseDecimal } from '@/store/blotter/blotterUtils.ts';
import type { BlotterOptionEntry } from '@/store/blotter/types/BlotterOptionEntry.ts';
import type { FlexiForwardProperties } from '@/store/flexi-forward/state.ts';

export function getFlexiFromBlotterEntry(entry: BlotterOptionEntry): FlexiForwardProperties {
  const amountCurrency = getCurrencyChoice(entry.dealtCurrency, entry.currencyPair);

  return {
    startDate: extractDay(entry.callabilityStartDate),
    currencyPair: entry.currencyPair,
    deliveryDate: extractDay(entry.deliveryDate),
    expiryDate: extractDay(entry.expiry),
    rate: parseDecimal(entry.forwardRate?.toString()),
    hedgeType: 'Live',
    cutOffMarketPlace: entry.cutOffPlace ?? '',
    notional: parseDecimal(entry.dealtAmount?.toString()),
    notionalCurrencyIndex: amountCurrency,
    priceCurrencyIndex: getCurrencyChoice(entry.premiumCurrency, entry.currencyPair),
    premiumDate: extractDay(entry.premiumPaymentDate),
    premiumType: 'AMOUNT',
    clientsWay: getTileSide(entry),
    premiumPaymentAmountAskString: entry.premium?.toString(),
    premiumPaymentAmountBidString: entry.premium?.toString(),
  };
}
